/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    sessionStart: z.coerce.date().default(() => new Date()),
    sessionEnd: z.coerce.date().nullish(),
    userAgent: z.string().nullish(),
    ipAddress: z.string().nullish(),
    userCreatedAt: z.coerce.date(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    sessionStart: z.coerce.date(),
    sessionEnd: z.coerce.date().nullish(),
    userAgent: z.string().nullish(),
    ipAddress: z.string().nullish(),
    userCreatedAt: z.coerce.date(),
}
).strict();
const relationSchema = z.object({
    user: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    userId: z.string(),
}
);

/**
 * `UserSessionLog` schema excluding foreign keys and relations.
 */
export const UserSessionLogScalarSchema = baseSchema;


/**
 * `UserSessionLog` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const UserSessionLogSchema = UserSessionLogScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const UserSessionLogPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const UserSessionLogPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    sessionStart: z.coerce.date(),
    sessionEnd: z.coerce.date().nullish(),
    userAgent: z.string().nullish(),
    ipAddress: z.string().nullish(),
    userCreatedAt: z.coerce.date()
}).partial().passthrough();


/**
 * `UserSessionLog` schema for create operations excluding foreign keys and relations.
 */
export const UserSessionLogCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, sessionStart: true
});


/**
 * `UserSessionLog` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const UserSessionLogCreateSchema = UserSessionLogCreateScalarSchema.merge(fkSchema);


/**
 * `UserSessionLog` schema for update operations excluding foreign keys and relations.
 */
export const UserSessionLogUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `UserSessionLog` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const UserSessionLogUpdateSchema = UserSessionLogUpdateScalarSchema.merge(fkSchema.partial());

